export const dashboardStats = {
  todaysCollection: {
    label: "Bugünkü Tahsilatlar",
    value: 124500,
    currency: "₺",
    change: 12.5,
    changeType: "positive" as const,
  },
  upcomingPayments: {
    label: "Yaklaşan Ödemeler",
    value: 67800,
    currency: "₺",
    count: 8,
  },
  overdueDebts: {
    label: "Geciken Alacaklar",
    value: 34500,
    currency: "₺",
    count: 5,
    change: -3.2,
    changeType: "negative" as const,
  },
  weeklyOrders: {
    label: "Bu Hafta Teslim",
    value: 12,
    unit: "sipariş",
  },
  totalReceivable: {
    label: "Toplam Alacak",
    value: 845200,
    currency: "₺",
  },
  totalPayable: {
    label: "Toplam Borç",
    value: 213500,
    currency: "₺",
  },
  netCash: {
    label: "Net Kasa",
    value: 631700,
    currency: "₺",
    change: 8.4,
    changeType: "positive" as const,
  },
};

export const urgentPayments = [
  {
    id: 1,
    customer: "Ahmet Yılmaz",
    phone: "+90 555 123 4567",
    amount: 12500,
    dueDate: "2026-05-01",
    daysOverdue: 2,
    status: "Gecikti",
  },
  {
    id: 2,
    customer: "Fatma Kaya",
    phone: "+90 555 234 5678",
    amount: 8900,
    dueDate: "2026-05-01",
    daysOverdue: 2,
    status: "Gecikti",
  },
  {
    id: 3,
    customer: "Mehmet Demir",
    phone: "+90 555 345 6789",
    amount: 15000,
    dueDate: "2026-05-03",
    daysOverdue: 0,
    status: "Yaklaştı",
  },
  {
    id: 4,
    customer: "Ayşe Çelik",
    phone: "+90 555 456 7890",
    amount: 6700,
    dueDate: "2026-05-04",
    daysOverdue: 0,
    status: "Yaklaştı",
  },
  {
    id: 5,
    customer: "Hasan Şahin",
    phone: "+90 555 567 8901",
    amount: 21000,
    dueDate: "2026-05-02",
    daysOverdue: 0,
    status: "Yaklaştı",
  },
];

export const upcomingOrders = [
  {
    id: 1,
    customer: "Selin Aydın",
    phone: "+90 555 678 9012",
    product: "14 Ayar Altın Yüzük",
    dueDate: "2026-05-01",
    daysLeft: 0,
    status: "Teslime Hazır",
  },
  {
    id: 2,
    customer: "Burak Özdemir",
    phone: "+90 555 789 0123",
    product: "22 Ayar Bilezik (20gr)",
    dueDate: "2026-05-02",
    daysLeft: 1,
    status: "Atölyede",
  },
  {
    id: 3,
    customer: "Zeynep Koç",
    phone: "+90 555 890 1234",
    product: "Taşlı Kolye (0.50ct)",
    dueDate: "2026-05-03",
    daysLeft: 2,
    status: "Hazırlanıyor",
  },
  {
    id: 4,
    customer: "Emre Yıldız",
    phone: "+90 555 901 2345",
    product: "Platin Alyans",
    dueDate: "2026-05-05",
    daysLeft: 4,
    status: "Alındı",
  },
];